import React from "react";
import TopicDetailComponent from "../components/topics/detail";

const TopicDetailPage = () => {
  return (
    <>
      <TopicDetailComponent />
    </>
  );
};

export default TopicDetailPage;
